import React from 'react'
import styles from './PotAmounts.module.css'
import { parseDecimalValuesOfNumber } from '../../../Common/utils/GameUtils'
import ChipComponent from './ChipComponent'
import { motion } from 'motion/react'

export default function PotAmount({ bigBlind, totalPotAmt, pot, winningPotData, index, run, hiddenPots, potsLength, isWinnerDeclared }) {
  // Calculate dynamic chipsHeight based on pot amount in big blind multiples
  const calculateChipsHeight = () => {
    if (!pot.potAmount || pot.potAmount === 0 || !bigBlind || bigBlind === 0) return 10; // Default fallback
    
    const minChips = 0;
    const maxChips = 15;
    
    // Calculate chips based on big blind multiples
    // 1 chip for every multiple of BB in the pot amount
    const bbMultiples = pot.potAmount / bigBlind;
    const calculatedChips = Math.round(bbMultiples);
    return 10 + Math.max(minChips, Math.min(maxChips, calculatedChips));
  };

  const numberOfChips = calculateChipsHeight();
  const chipArray = Array.from({ length: numberOfChips });

  const pot2HiddenAnimation = {
    scale: hiddenPots.includes(index + potsLength) ? 0 : 1,
    opacity: hiddenPots.includes(index + potsLength)
      ? 0
      : winningPotData &&
        isWinnerDeclared &&
        index + potsLength !== winningPotData?.potIndex
        ? 0.25
        : 1,
  }

  const pot1HiddenAnimation = {
    scale: hiddenPots.includes(index) ? 0 : 1,
    opacity: hiddenPots.includes(index)
      ? 0
      : winningPotData && index !== winningPotData?.potIndex
        ? 0.25
        : 1,
  }
  // //console.log('Spruha log >>> Winning Pot Data >>> ', JSON.stringify(winningPotData, null, 2))
  return (
    <motion.div
      initial={{
        scale: 1,
        opacity: 0,
      }}
      animate={run === 1 ? pot1HiddenAnimation : pot2HiddenAnimation}
      className={styles.potAmount}>
      {
        winningPotData ?
          winningPotData?.winnerNames.map((winner, winnerIndex) =>
            chipArray.map((item, chipIndex) => (
              <ChipComponent
                key={
                  "run" + run + "-winner-" +
                  winnerIndex +
                  "-potIndex-" +
                  index +
                  "-chipIndex-" +
                  chipIndex
                }
                index={index}
                chipIndex={chipIndex}
                winnerIndex={winnerIndex}
                winningPotData={winningPotData}
                winner={winner}
                shouldAnimate={
                  winningPotData &&
                    run === 2 ? (index + potsLength === winningPotData?.potIndex) : (index === winningPotData?.potIndex) &&
                    winningPotData?.playAnimation &&
                  winningPotData?.run === pot.run
                }
              />
            ))
          )
          : (
            chipArray.map((item, chipIndex) => (
              <ChipComponent key={`run-${run}-potIndex-${index}-chipIndex-${chipIndex}`} index={index} pot={pot} chipIndex={chipIndex} />
            ))
          )}
      <span className={styles.potAmountValue}>{parseDecimalValuesOfNumber(pot.potAmount, 2, true, true)}</span>
    </motion.div>
  )
}
